import { ErrorPage } from 'app/components/Common/ErrorPage/ErrorPage';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function Unauthenticated() {
  const { t } = useTranslation();
  return <ErrorPage text={t('authentication.unauthenticated')} />;
}
